<span class="badge badge-pill {{ status ? styles[status] : '' }}">{{ status ? (('centerStatus.'+status) | translate) : ''}}</span>